<script>
export default {
  render() {}
}
</script>
